// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vL1Z4","rootMobile":"styles_rootMobile__2z5Xo"};